import { EncounterCosign, EncounterSummaryControllerApi } from "@/services";
import { getConfigObject, useMutationWithLoading } from "@/utils/utils";

/** Adds the one co-sign text and signature to a signed-off visit; only the assigned co-signer can. */
export const useSignCosign = () =>
  useMutationWithLoading(
    async (params: {
      appointmentUuid: string;
      encounterCosign: EncounterCosign;
      xTENANTID?: string;
    }) =>
      new EncounterSummaryControllerApi(getConfigObject()).signCosign(
        params.appointmentUuid,
        params.encounterCosign,
        params.xTENANTID
      )
  );
